const clockedElements = ['bpmn:UserTask', 'bpmn:ServiceTask', 'bpmn:SubProcess', 'bpmn:Task']

const render = (canvas, overlayinfo: any) => {
    const overlays: any = canvas.get('overlays')
    const taskdata: any = Array.from(overlayinfo.taskdata).sort((a: any, b: any) => a.count - b.count)
    const tasks: any = canvas.get('elementRegistry').filter((element) => clockedElements.includes(element.type))
    tasks.forEach((element: any) => {
      const radialGradient = generateRadialGradient(element, taskdata)
      const overlayStyle = `background-image: ${radialGradient}; width: ${element.width}px; height: ${element.height}px;`
      const taskHeatmap = `<div class='task-heatmap' style="${overlayStyle}"></div>`
      overlays.add(element.id, {
        position: {
          bottom: element.height,
          right: element.width
        },
        html: `<div class='task-overlay'>${taskHeatmap}</div>`
      })
    })
}

const percentRank = (array, n) => {
    var L = 0;
    var S = 0;
    var N = array.length

    for (var i = 0; i < array.length; i++) {
        if (array[i].count < n) {
            L += 1
        } else if (array[i].count === n) {
            S += 1
        }
    }

    var pct = (L + (0.5 * S)) / N

    return Math.floor(pct * 100)
}

const generateRadialGradient = (element, taskdata) => {
  const red = (percentileRank) => `hsl(0, 100%, 50%) ${percentileRank > 75 ? percentileRank - 21 : 0}%`
  const yellow = (percentileRank) => `hsl(60, 100%, 50%) ${percentileRank > 50 ? percentileRank - 18 : 0}%`
  const green = (percentileRank) => `hsl(120, 100%, 50%) ${percentileRank > 25 ? percentileRank - 12 : 0}%`
  const cyan = (percentileRank) => `hsl(180, 100%, 50%) ${percentileRank > 0 ? percentileRank : 0}%`
  const blue = () => `hsl(240, 100%, 50%) ${100}%`

  const taskCount = taskdata.filter((taskdatum) => taskdatum.id === element.id)[0].count
  const rank = percentRank(taskdata, taskCount)

  return `radial-gradient(ellipse at center, ${red(rank)}, ${yellow(rank)}, ${green(rank)}, ${cyan(rank)}, ${blue()})`
}

export default render
